import { ThunkDispatch } from 'redux-thunk';

import { CategoriesApi } from 'api';
import { setDictionary } from 'features/dictionaries/store/actions';
import { DictionaryRecordContent } from 'features/dictionaries/store/interface';
import { CategoryDataInterface } from 'shared/interface';
import { FETCH_CATEGORIES, FETCH_POPULAR_CATEGORIES } from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

const normalizeCategoriesData = (categories: CategoryDataInterface[]) => {
	return categories.reduce((categoriesObj, category) => {
		categoriesObj[category.categoryId] = category;
		return categoriesObj;
	}, {} as Record<number, CategoryDataInterface>);
};

function mapCategoryToDictionaryName(category: CategoryDataInterface): string {
	if (category.level === 3) {
		return `${category.sportName} (${category.parentName} > ${category.categoryName})`;
	} else if (category.level === 2) {
		return `${category.sportName} (${category.categoryName})`;
	} else {
		return category.sportName;
	}
}

export const fetchCategories = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const response = await CategoriesApi.getAllCategories();
			const categoriesObj = normalizeCategoriesData(response.data.data.categories);
			dispatch(
				createAction(FETCH_CATEGORIES, {
					all: categoriesObj,
				}),
			);

			dispatch(
				setDictionary({
					recordType: 'categories',
					recordContent: response.data.data.categories.reduce((acc: DictionaryRecordContent, cur: CategoryDataInterface) => {
						acc[cur.categoryId] = mapCategoryToDictionaryName(cur);
						return acc;
					}, {}),
				}),
			);
		} catch (err) {
			console.error('err', err);
		}
	};
};

export const fetchPopularCategories = (filter: string | undefined) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const response = await CategoriesApi.getPopularCategories(filter);
			const popular = normalizeCategoriesData(response.data.data.popular);
			const filtered = normalizeCategoriesData(response.data.data.categories);
			dispatch(
				createAction(FETCH_POPULAR_CATEGORIES, {
					popular,
					filtered,
				}),
			);
		} catch (err) {
			console.error('err', err);
		}
	};
};
